import { Injectable } from '@angular/core';
import {EventsWebsocketService} from "./entities/events-websocket.service";
import {Socket} from "socket.io-client";
import {DefaultEventsMap} from "@socket.io/component-emitter";
import {DoWhenReadyService, Readyables} from "./do-when-ready.service";
import {WebsocketService} from "./websocket.service";
import {Store} from "@ngrx/store";
import {EntitySeederService} from "./entities/entity-seeder.service";
import {selectWorldReady} from "../state/world/world.selector";
import * as AuthSelectors from "../state/auth/auth.selector";
import {auditTime, BehaviorSubject, map} from "rxjs";
import { GenericSearchResults} from "./dtos/generic-search-result.dto";
import {serverEntityToEntity} from "./dtos/server-entity.dto";

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  debug = false

  public socket: Socket<DefaultEventsMap, DefaultEventsMap>;
  constructor(
      private store: Store,
      private websocketService: WebsocketService,
      private doWhenReady: DoWhenReadyService
  ) {
    this.websocketService.eventsSocket.subscribe(async (socket) => {
      if (!socket) return
      this.socket = socket
    })
    this.doWhenReady.everyTime(this, [Readyables.network], async (user) => {
    })
    this.searchTerm.pipe(auditTime(500)).subscribe(async (term) => {
        await this.searchTermUpdated(term)
    })
  }

  searchResults: BehaviorSubject<GenericSearchResults> = new BehaviorSubject({
    users: [],
    entities: []
  })
  searchTerm: BehaviorSubject<string> = new BehaviorSubject(null)

  log(msg) {
    if (this.debug) {
      console.log(msg)
    }
  }

  async searchTermUpdated(term: string) {
    const results = await this.socket.emitWithAck("search_keystroke", {
      term: term
    })
    this.log("Got term:" + term)
    this.log("Got results:" + JSON.stringify(results))
    this.searchResults.next({
      users: results.users,
      entities: results.entities.map((e) => serverEntityToEntity(e))
    })
  }

  async clearSearch() {
    this.searchTerm.next(null)
    this.searchResults.next({
      users: [],
      entities: []
    })
  }
}
